import type { Entry, EntryFieldTypes } from 'contentful';

import { contentfulClient } from '@/apis/contentful';

export interface ReleaseNoteSkeleton {
  contentTypeId: 'releaseNotes';
  fields: {
    releaseTitle: EntryFieldTypes.Text;
    releaseDescription: EntryFieldTypes.RichText;
    releaseMedia: EntryFieldTypes.AssetLink;
    publishDate: EntryFieldTypes.Date;
  };
}

export type ReleaseNote = Entry<ReleaseNoteSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>;

export function getReleaseNotes() {
  return contentfulClient.withoutUnresolvableLinks.getEntries<ReleaseNoteSkeleton>({
    content_type: 'releaseNotes',
    order: ['-sys.createdAt'],
  });
}
